module.exports = __webpack_public_path__ + "img/main-mob.daa6260c.svg";